import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { whitePlainsConfig } from "./data";

export default function WhitePlainsPage() {
  return <CityPageTemplate config={whitePlainsConfig} />;
}